import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import socketService from "@/services/socketService";
import DeliverHubSidebar from "@/components/delivery-hub/DeliverHubSidebar";
import ChatWidget from "@/components/delivery-hub/ChatWidget";
import { DeliveryHubProvider } from "@/contexts/DeliveryHubContext";

const DeliverHubLayout = () => {
  // Live chat messages and unread badges need the socket (the CRM Layout connects it
  // for the main app; DeliveryHub has its own layout)
  useEffect(() => {
    socketService.connect();
    return () => socketService.disconnect();
  }, []);

  return (
    <DeliveryHubProvider>
      <div className="flex h-screen bg-gray-50">
        {/* Sidebar */}
        <DeliverHubSidebar />

        {/* Main Content */}
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
      <ChatWidget />
    </DeliveryHubProvider>
  );
};

export default DeliverHubLayout;
